/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2022-10-31 09:47:28
 * @Description: 
 */
import React, { useEffect } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/modules/effect-coverflow/effect-coverflow.scss";
import 'swiper/swiper.scss';
import "swiper//modules/navigation/navigation.scss";
import "swiper/modules/pagination/pagination.scss";

// import required modules
import { Autoplay, Pagination } from "swiper";
import urls from "src/constant/url";
import "./FTNoImageLinkToAIGC.scss"
import { getAIGCLink } from "src/utils";
import FTAnalytic from "src/analyze/FTAnalytic";
export default function FTNoImageLinkToAIGC() {
  const [analyticObj, setAnalyticObj] = React.useState<any>({})

   useEffect(() => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$show$fortor_ad',
      label: {
        location: 'goart_web_mobile_banner',
        button_position: `${list[0].type}_banner`,
        jump_url: list[0].url
      }
    })
    setAnalyticObj({
      ...analyticObj,
      [list[0].type]: true
    })
  },[])
  const list = [
    {
      image: urls.assetsUrl + "/img/aigc/banner-av.jpg",
      url: getAIGCLink("toAvatar"),
      type: "avatar"
    },
    {
      image: urls.assetsUrl + "/img/aigc/banner-text.jpg",
      url: getAIGCLink("textToImage"),
      type: "text2img"
    },
    {
      image: urls.assetsUrl + "/img/aigc/banner-photo.jpg",
      url: getAIGCLink("imageToImage"),
      type: "img2img"
    }
  ]
  const preventDefault = (e: any) => {
    e.preventDefault && e.preventDefault()
    e.stopPropagation && e.stopPropagation()
  }
  const handleClick = (e: any, value: any) => {
    preventDefault(e)
    window.open(value.url)

    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$click_up$fortor_ad',
      label: {
        location: 'goart_web_mobile_banner',
        button_position: `${value.type}_banner`,
        jump_url: value.url
      }
    })
  } 
  return (
    <>
      <div className="mySwiper">
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            bulletActiveClass: "bullet-active",
            bulletClass: "bullet-default"
          }}
          modules={[Autoplay, Pagination]}
          onSlideChange={(e) => {
            const value = list[e.activeIndex];
            setTimeout(() => {
              if (!analyticObj[value.type]) {
                FTAnalytic.addAnalytic({
                  type: 'ev',
                  analyticType: "sa",
                  action: 'fotor_web$show$fortor_ad',
                  label: {
                    location: 'goart_web_mobile_banner',
                    button_position: `${value.type}_banner`,
                    jump_url: value.url
                  }
                })
                setAnalyticObj({
                  ...analyticObj,
                  [value.type]: true
                })
              }
            }, 1000);

          }}
        >
          {list.map((item: any) => {
            return <SwiperSlide key={item.image} onMouseDown={preventDefault} onClick={(e) => handleClick(e, item)}>
              <img src={item.image} alt="" />
            </SwiperSlide>
          })}
        </Swiper>
      </div>
    </>
  );
}
